import React, { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import DataTable from 'components/DataTable/DataTable';
import EmptyState from 'components/EmptyState/EmptyState';
import BillingCapacityMove from 'Customers/BillingCapacity/BillingCapacityMove';

import { PACKAGE_NAMES } from '../../../constants';
import EditSubscriptionModal from '../EditSubscriptionModal/EditSubscriptionModal';
import TenantSubscriptionsTableRow from '../TenantSubscriptionsTableRow/TenantSubscriptionsTableRow';

const headerCells = [
  { title: 'plan', sortable: true, sortValue: 'plan' },
  { title: 'status', sortable: true, sortValue: 'status' },
  { title: 'mrr', sortable: true, sortValue: 'mrr' },
  { title: 'start date', sortable: true, sortValue: 'startDate' },
  { title: 'renewal date', sortable: true, sortValue: 'renewalDate' },
  { title: '' },
];

// The table library remounts its row subtree on refetch. Keep the original Move
// review (and its separately consented purchase editor) above that subtree.
const TenantSubscriptionsTable = ({ subscriptions, isLoading }) => {
  const queryClient = useQueryClient();
  const [move, setMove] = useState(null);
  const [editPreview, setEditPreview] = useState(null);
  const [purchaseReceipt, setPurchaseReceipt] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const openMove = (selected) => {
    setPurchaseReceipt(null);
    setRefresh(0);
    setMove(selected);
  };
  return (
    <>
      <DataTable
        isScroll
        data={subscriptions}
        isLoading={isLoading}
        columns={headerCells}
        TableRowComponent={TenantSubscriptionsTableRow}
        rowAdditionalProps={{ onOpenMove: openMove }}
        EmptySearchComponent={() => <EmptyState message={'No Subscription'} />}
      />
      {move && (
        <>
          <BillingCapacityMove
            key={move.id}
            subscriptionId={move.id}
            plan={PACKAGE_NAMES[move.plan] || move.plan}
            billingCapacity={move.billingCapacity}
            initiallyOpen
            hideTrigger
            purchaseReceipt={purchaseReceipt}
            refreshKey={refresh}
            onEdit={setEditPreview}
            onDismiss={() => setMove(null)}
            onSuccess={() => queryClient.invalidateQueries({ queryKey: ['TenantSubscriptions'] })}
          />
          <EditSubscriptionModal
            isOpen={!!editPreview}
            selected={move}
            billingPreview={editPreview}
            onPurchaseComplete={setPurchaseReceipt}
            onClose={() => {
              setEditPreview(null);
              setRefresh((current) => current + 1);
            }}
          />
        </>
      )}
    </>
  );
};

export default TenantSubscriptionsTable;
